{
  "salon-visited-page": {
    "buttons": {
      "book-appointment": "REZERVOVAT SCHŮZKU"
    },
    "text": {
      "no-visited-salon": "Žádný navštívený salon nelze nalézt",
      "promotional-message": "Propagační sdělení",
      "visited-salon": "Navštívené salony"
    },
    "meta": {
      "title": "Navštívené salony",
      "description": "Seznam navštívených salonů"
    }
  }
}
